import React, { useEffect, useState } from 'react';

import GenericEditable from './shared/GenericEditable';
import DisplayNumber from './number/DisplayNumber';
import EditNumber from './number/EditNumber';

/**
 * Curency editable in popup after click. Value can't be null, if empty 0 is set.
 * @param {number} [initialValue] Initial field value.
 * @param {function} [customDisplayWrapper] [string=>component]Optional wrapper for the displayed value (e.g. for setting <h1>).
 * @param {string} [description] E.g. "Change value:".
 * @param {function} [handleSave] [async string=>{bool success, string message}] Save changes / return error message.
 */
const EditableCurrency = ({ initialValue: onPageLoadValue, customDisplayWrapper, description, handleSave: syncChanges, updateStore }) => {
    const [value, setValue] = useState(onPageLoadValue !== undefined && onPageLoadValue !== null ? onPageLoadValue : 0);
    const [initialValue, setInitialValue] = useState(onPageLoadValue !== undefined && onPageLoadValue !== null ? onPageLoadValue : 0);

    useEffect(() => {
        setValue(onPageLoadValue !== undefined && onPageLoadValue !== null ? onPageLoadValue : 0);
        setInitialValue(onPageLoadValue !== undefined && onPageLoadValue !== null ? onPageLoadValue : 0);
    }, [onPageLoadValue]);

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        if (value === null) {
            const response = await syncChanges(0);
            if (response.success) {
                setValue(0);
                setInitialValue(0);
            }
            return response;
        } else if (isNaN(value)) {
            return { success: false, message: 'Måste vara ett tal.' };
        } else {
            const response = await syncChanges(value);
            if (response.success) {
                updateStore(response.deal);
                setInitialValue(value);
            }
            return response;
        }
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericEditable {...{ handleSave, handleCancel, customDisplayWrapper, description, valueHasntChanged }}>
            <DisplayNumber {...{ value: initialValue }} isCurrency />
            <EditNumber {...{ value, setValue }} isCurrency />
        </GenericEditable>
    );
};

export default EditableCurrency;
